import { defineComponent as _defineComponent } from 'vue'
import { campaignOptions } from '@/utils/campaign'

export default /*#__PURE__*/_defineComponent({
  __name: 'PromoProButton',
  setup(__props) {


return { __sfc: true,campaignOptions }
}

})